import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Toolbar, Button, Badge, Hidden } from '@material-ui/core';
import { Work, Business, Bookmark, Forum } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        height: '5rem',
    },
    toolbar: {
        height: '100%',
        minHeight: '5rem',
        padding: 0,
        background: '#52bbf8',
        display: 'flex',
        justifyContent: 'stretch',
    },
    button: {
        height: '100%',
        fontSize: '1.8rem',
        color: 'white',
        padding: '0 1rem',
        flex: 1,
        borderRadius: 0,
        '&:hover': {
            backgroundColor: '#ffdd57',
            color: '#066298',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.2rem',
            padding: '0 0.5rem',
        },
    },
    link: {
        textDecoration: 'none',
        flex: 1,
        display: 'flex',
        height: '100%',
    },
    icon: {
        marginRight: theme.spacing(1),
    },
    badge: {
        '& .MuiBadge-badge': {
            backgroundColor: '#ffdd57',
            color: '#066298',
        },
    },
}));

function GlobalNav() {
    const classes = useStyles();
    const currentUser = useSelector(state => state.user.currentUser);
    const candidateCount = useSelector(state => state.common.candidateCount);
    const userType = currentUser ? currentUser.profile.user_type : null;
    const isVerified = currentUser ? currentUser.verified : false;

    const renderLinks = () => {
        let linkContents = null;
        if (userType === 'Business' && isVerified) {
            linkContents = (
                <Link to="/personalprofiles" className={classes.link}>
                    <Badge badgeContent={candidateCount} className={classes.badge}>
                        <Button
                            className={classes.button}
                            startIcon={<Hidden smDown><Work className={classes.icon} /></Hidden>}
                        >
                            求職者リスト
                        </Button>
                    </Badge>
                </Link>
            );
        } else if (userType === 'Personal') {
            linkContents = (
                <Link to="/mypage/savedjoblist" className={classes.link}>
                    <Button
                        className={classes.button}
                        startIcon={<Hidden smDown><Bookmark className={classes.icon} /></Hidden>}
                    >
                        保存リスト
                    </Button>
                </Link>
            );
        }

        return (
            <Fragment>
                <Link to="/jobs" className={classes.link}>
                    <Button
                        className={classes.button}
                        startIcon={<Hidden smDown><Work className={classes.icon} /></Hidden>}
                    >
                        求人検索
                    </Button>
                </Link>
                <Link to="/profiles" className={classes.link}>
                    <Button
                        className={classes.button}
                        startIcon={<Hidden smDown><Business className={classes.icon} /></Hidden>}
                    >
                        企業紹介
                    </Button>
                </Link>
                <Link to="/thread" className={classes.link}>
                    <Button
                        className={classes.button}
                        startIcon={<Hidden smDown><Forum className={classes.icon} /></Hidden>}
                    >
                        自由投稿板
                    </Button>
                </Link>
                {linkContents}
            </Fragment>
        );
    };

    return (
        <div className={classes.root}>
            <AppBar position="static" elevation={1}>
                <Toolbar className={classes.toolbar}>
                    {renderLinks()}
                </Toolbar>
            </AppBar>
        </div>
    );
}

export default GlobalNav;